import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import SocialUpdate from "../social_update";
import SocialUpdateBody from "../social_update_body";
import ReadingChallengeBadge from "../../reading_challenge/reading_challenge_badge";
import ReadingChallengeJoinDetails from "./reading_challenge_join_details";
import ReadingChallengeCompleteDetails from "./reading_challenge_complete_details";

export default GrComponentFactory.createClass({
  displayName: "ReadingChallengeNewsfeedItem",
  propTypes: {
    resource: React.PropTypes.shape({
      user: GrPropTypes.user().isRequired,
      url: React.PropTypes.string.isRequired,
      goalNum: React.PropTypes.number.isRequired,
      numRead: React.PropTypes.number.isRequired,
      challenge: GrPropTypes.readingChallenge(),
      books: React.PropTypes.arrayOf(GrPropTypes.book()),
    }),
    urcDeprecateViewChallengeLink: React.PropTypes.bool,
  },

  getSocialUpdateBody() {
    const challengeIcon = <ReadingChallengeBadge challenge={this.props.resource.challenge} />;

    return <SocialUpdateBody customIcon={challengeIcon}>
             {this.props.resource.challenge.isFinished ?
              <ReadingChallengeCompleteDetails ref="challengeCompleteDetails" {...this.props.resource}
              urcDeprecateViewChallengeLink={this.props.urcDeprecateViewChallengeLink} /> :
              <ReadingChallengeJoinDetails ref="challengeJoinDetails" {...this.props.resource} />
             }
           </SocialUpdateBody>;
  },

  renderHeaderText() {
    const challenge = this.props.resource.challenge;
    const text = this.props.resource.challenge.isFinished ? "has completed the " : "has joined the ";
    return <span>
             {text}
             <a className="gr-hyperlink--bold"
                href={challenge.url}>
               {challenge.title}
             </a>
           </span>;
  },

  render() {
    return <SocialUpdate
        header={this.renderHeaderText()}
        body={this.getSocialUpdateBody()}
        {...this.props}
      />;
  },
});
